import { render, staticRenderFns } from "./FooterWs.vue?vue&type=template&id=38b3b3fd&scoped=true&"
import script from "./FooterWs.vue?vue&type=script&lang=js&"
export * from "./FooterWs.vue?vue&type=script&lang=js&"
import style0 from "./FooterWs.vue?vue&type=style&index=0&id=38b3b3fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b3b3fd",
  null
  
)

export default component.exports